import * as Yup from "yup";

type ISectionSchema = {
  name: string;
};

const sectionSchema: Yup.ObjectSchema<ISectionSchema> = Yup.object().shape({
  name: Yup.string().required("Section Name is required."),
});

export { sectionSchema };
export type { ISectionSchema };
